<template>
    <div style="height: 1px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="1" width="1" viewBox="0 0 1 1">
            <defs>
                <marker
                    id="arrowhead" markerWidth="6" markerHeight="6" refX="0" refY="3"
                    orient="auto"
                >
                    <polygon points="0 0, 6 3, 0 6" stroke-width="1" />
                </marker>
            </defs>
        </svg>
        <div
            v-for="arrow in arrows"
            :key="arrow.id"
            :class="['task-dep-arrow', arrow.cls]"
            :style="{top: arrow.top + 'px', height: arrow.height + 'px', left: arrow.left + 'px' }"
        >
            <svg width="18" :height="arrow.height" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path :d="arrow.path" stroke-width="2" stroke="#000000" fill="none" marker-end="url(#arrowhead)" />
            </svg>
        </div>
    </div>
</template>

<script>
import { ref, reactive, computed, watch } from "@vue/composition-api";

export default {
    name: "DependencyArrows",
    props: {
        dependencies: {
            type: Array,
            required: true
        },
        relativeElem: {
            type: HTMLElement,
            default: null
        }
    },
    setup(props) {
        const changed = computed(() => {
            return props.dependencies;
        });
        const arrows = ref([]);

        /*const arrows = computed(() => {

        });*/
        const redraw = () => {
            let ret = [];
            for (let dependency of props.dependencies) {
                let elFrom = document.getElementById("tbl-row-" + dependency[1]);
                if (elFrom == null) continue;

                let elTo = document.getElementById("tbl-row-" + dependency[0]);

                let arrowFromPosition = elFrom.offsetTop
                let arrowToPosition = elTo.offsetTop
                let rowHeight = elFrom.getBoundingClientRect().height
                let halfRowHeight = rowHeight / 2

                if (props.relativeElem) {
                    arrowFromPosition = elFrom.getBoundingClientRect().y - props.relativeElem.getBoundingClientRect().y
                    arrowToPosition = elTo.getBoundingClientRect().y - props.relativeElem.getBoundingClientRect().y
                }

                let arrowHeight = Math.abs(arrowFromPosition - arrowToPosition)

                let arrow = {
                    id: "{0}-{1}".format(dependency[0], dependency[1]),
                    cls: "dep-arrow-{0}".format(dependency[0]),
                    left: -18,
                    top: Math.min(arrowFromPosition, arrowToPosition),
                    height: (arrowHeight + rowHeight),
                    path: "M17,{0} L1,{0} L1,{1} L5,{1}".format(
                        arrowFromPosition > arrowToPosition ? arrowHeight + halfRowHeight : halfRowHeight,
                        arrowFromPosition > arrowToPosition ? halfRowHeight : arrowHeight + halfRowHeight
                    )
                }

                ret.push(arrow);
            }
            arrows.value = ret;
        };

        watch(changed, () => {
            setTimeout(redraw, 300);
        });
        window.addEventListener('resize', () => {
            redraw();
        });

        return {
            arrows
        };
    }
}
</script>
